import dynamic from 'next/dynamic'

const PreferencesModal = dynamic(
  import(
    /* webpackChunkName: "preferences" */
    'components/Preferences/Modal/Preferences'
  ),
  {
    ssr: false,
  }
)

export default PreferencesModal
